import { AppealStatus } from '../type'

// получение "прав" на отображение разделов в форме управления заказом по статусу
export const getRightsForOrderManage = (
  type: 'manage' | 'cancel' | 'changeVisit' | 'dealer',
  status: AppealStatus,
): boolean => {
  const fullRights = [
    'DEALER_SELECTED',
    'VISIT_OFFER',
    'VISIT_PAID',
    'OFFER',
    'OFFER_PAID',
    'PROCESSING',
    'GRADE_WAITING',
    'FIXING',
  ]

  const cancelRights = ['DEALER_SELECTED', 'VISIT_OFFER']

  const measurement = [
    'DEALER_SELECTED',
    'VISIT_OFFER',
    'VISIT_PAID',
    'PROCESSING',
  ]

  switch (type) {
    case 'manage':
      return fullRights.includes(status)
    case 'dealer':
      return fullRights.includes(status)
    case 'cancel':
      return cancelRights.includes(status)
    case 'changeVisit':
      return measurement.includes(status)
  }
}
